import React from 'react';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import config from '../app/config';
import { setAlertMessage } from '../features/layoutSlice';

function useCookies(key, initialValue) {
  const dispatch = useDispatch();

  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = React.useState(() => {
    // Try to get storedValue from cookie storage or return initialValue if none.
    try {
      const item = Cookies.get(key);
      return item || initialValue;
    } catch (error) {
      dispatch(setAlertMessage({ text: error, type: 'error' }));
      return initialValue;
    }
  });
  // Wrapped version of useState's setter function that persists the new value to cookie storage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      Cookies.set(key, valueToStore, { expires: config.cookies.expirationTime });
    } catch (error) {
      dispatch(setAlertMessage({ text: error, type: 'error' }));
    }
  };
  return [storedValue, setValue];
}

export default useCookies;
